var map = {
	"./archii-dark-light.svg": 550,
	"./archii-dark-white.svg": 551
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 549;


//////////////////
// WEBPACK FOOTER
// ./apps/assets/img ^\.\/archii\-dark\-.*\.svg$
// module id = 549
// module chunks = 0